<template>
  <div id="map-styles">
    <div v-for="(value, index) in mapStyleList"
         :key="index" vs-type="flex" class="mt-4">
      <vs-radio class="w-full" :color="AISEA_COLOR.BLUE" v-model="selectedStyleType" :vs-value="value.id">
        <div class="map-styles-container w-full">
          <div class="item1"><span class="aisea-text-14-400-white">{{ value.name }}</span></div>
          <div class="item2"><img :src="value.img" :class="imgClassObject(value.id)"></div>
        </div>
      </vs-radio>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

// Mixins
import {LayerMixin, ColorMixin} from "@/mixins";

// Store
const {
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

const {
  mapGetters: mapGettersOfMapSetting
} = createNamespacedHelpers("mapSetting");

export default {
  mixins: [LayerMixin, ColorMixin],
  components: {},
  data() {
    return {
      selectedStyleType: 1,
    };
  },
  watch: {
    selectedStyleType(id) {
      let mapStyle = this.mapStyleList.find(v => {
        return v.id === id
      })
      this.SET_MAP_STYLE(mapStyle.url)
      this.saveUsersMapStyle(id)
    }
  },
  computed: {
    ...mapGettersOfLiveMap(["getMetoceanInitialDatetime", "getCurrentMetoceanSourceLayerId"]),
    ...mapGettersOfMapSetting(["getStyle"]),
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_MAP_STYLE",
    ]),
    imgClassObject(id) {
      return {
        selectStyle: id === this.selectedStyleType,
      }
    },
  },
  async mounted() {
    let url = await this.getUsersMapStyle()
    let mapStyle = this.mapStyleList.find(v => {
      return v.url === url
    })
    this.selectedStyleType = mapStyle.id
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#map-styles {

  .map-styles-container {
    display: flex;
    justify-content: space-between;
  }

  .item1 {
    flex: 1;
    align-self: center;
  }

  .item2 {
    flex: 0;
    align-self: center;
    margin-right: auto;
  }

  .vs-radio--label {
    width: 100%;
  }


  .map-img {
    width: 200px;
    margin-right: auto;
  }

  img {
    width: 90px;
    height: 67.5px;
    border-radius: 5px;
  }

  .selectStyle {
    border: 2px solid $aisea-blue;
    box-sizing: border-box;
  }
}

</style>
